<zimmerer-route-ion-wrapper class="ion-page">

  <image-slider [fxHide]="!hasSliderImages" [page]="'partners'" fxHide.gt-md></image-slider>

  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col" [class.withTopPadding]="mobileService.isMobile" [class.noSlider]="!hasSliderImages"
      fxLayout="column" fxLayoutGap="20px">
      <image-slider [fxHide]="!hasSliderImages" [page]="'partners'" fxHide.lt-lg></image-slider>

      <h1 class="contentHeadline">Kooperationspartner</h1>

      <p>
        Der Zimmerer-Treffpunkt ist für Handwerker immer kostenlos. Dieses Netzwerk finanziert sich durch Kooperationen
        mit Lieferanten und wird unterstützt von Organisationen, die den Holzbau bewusst fördern wollen.
      </p>

      <p>
        Wir bedanken uns recht herzlich bei:
      </p>

      <!-- partner logos -->
      <div fxLayout="column" fxLayoutAlign="start stretch" fxLayout.gt-sm="row wrap" fxLayoutAlign.gt-sm="center center"
        class="partnerlogos">

        <div *ngFor="let partnerlogo of sliderItems" class="partnerlogoboxwrapper" fxFlex.gt-sm="50"
          [fxFlex.gt-md]="100/3+'%'">

          <div class="partnerlogobox">
            <a [href]="partnerlogo.link" target="_blank" [class]="partnerlogo.name+' partnerlogo'" fxLayout="row"
              fxLayoutAlign="center center" [style.background-image]="partnerlogo.safe">
            </a>
          </div>
        </div>
      </div>

      <app-slider [sliderItems]="PartnerService.partnerStatements"
        headline="Was unsere Kooperationspartner über uns sagen:"></app-slider>

      <div class="contentHeadline">«Zimmermann» ist der schönste Beruf der Welt.</div>

      <p>
        Diese Plattform soll ihm dabei helfen, erfolgreich zu sein, sich weiterentwickeln zu können und besser zu
        werden.
        Und sie soll gleichzeitig für interessierte Partner und Zulieferer einen Beitrag leisten, ihre innovativen
        Produkte, die dem Zimmerer einen Mehrwert bieten, zugänglich zu machen. Eine Kooperationspartnerschaft mit dem
        Zimmerer-Treffpunkt ist eine Win-Win-Situation.
      </p>

      <p>
        Unsere Kooperationspartner bringen den Mehrwert, den sie den Zimmerern bieten können und wir kommunizieren ihn.
        Vor allem soll eine Partnerschaft mit dem Treffpunkt aber eines sein: Ein Bekenntnis zum Holzbau und zum Beruf
        des
        Zimmerers.
      </p>

      <p>
        Hast Du Interesse an einer Kooperationspartnerschaft mit uns? Willst Du innovative Produkte vorstellen? Oder
        willst Du einfach unsere Arbeit und den Holzbau unterstützen? Dann lass uns darüber sprechen.
      </p>

      <div fxLayout="row" fxLayoutAlign="center center">
        <button class="orange-button" (click)="gotoContact()">Jetzt Kontakt aufnehmen</button>
      </div>

    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>